import { PriceModel } from './Price.model';
import { ModelContext } from './ModelContext';
import { cartV2 } from '@wix/ecom';

export class AdditionalFeeModel {
  public price?: PriceModel;
  public code?: string | null;
  public name?: string;

  constructor(additionalFeeModel: AdditionalFeeModel) {
    this.price = additionalFeeModel.price;
    this.code = additionalFeeModel.code;
    this.name = additionalFeeModel.name;
  }

  public static fromV2(
    additionalFee: cartV2.V2AdditionalFee,
    modelContext: ModelContext,
  ) {
    return new AdditionalFeeModel({
      price: PriceModel.fromV2(additionalFee.price, modelContext),
      code: additionalFee.code,
      name:
        additionalFee.name?.translated ??
        additionalFee.name?.original ??
        /* istanbul ignore next */ '',
    });
  }
}
